var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectTags',{attrs:{"placeholder":_vm.placeholder,"size":_vm.size,"value":_vm.valueComponent,"options":_vm.optionsComponent,"horizontal":_vm.horizontal,"label":_vm.label},on:{"update:value":function($event){_vm.valueComponent=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }